import React from 'react';

const SeatAndBelt = ({ belt, seat, color }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 365 387"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="357" height="387" transform="translate(4)" fill="none" />
      <g filter="url(#filter0_d_14_107)">
        <path
          d="M98.2095 32C98.2095 14.3269 112.536 0 130.21 0H233.209C250.882 0 265.21 14.3269 265.21 32C265.21 49.6731 250.882 64 233.209 64H130.21C112.536 64 98.2095 49.6731 98.2095 32Z"
          fill={color || '#2e3448'}
        />
        <path
          d="M53.2094 89.5C53.2094 61.3335 76.043 38.5 104.21 38.5H260.209C288.376 38.5 311.21 61.3335 311.21 89.5V176.5L319.229 265.946C321.905 295.79 298.397 321.5 268.433 321.5H99.4156C70.2142 321.5 46.9751 297.028 48.4835 267.866L53.2094 176.5V89.5Z"
          fill={color || '#2e3448'}
        />
        <path
          d="M8.45268 250.498C10.7862 245.161 15.5946 241.29 21.2959 240.095L41.3815 235.883C42.5963 235.628 43.8342 235.5 45.0754 235.5H318.597C319.669 235.5 320.739 235.596 321.795 235.786L344.301 239.85C351.502 241.15 357.289 246.668 358.626 253.862C360.849 265.82 361.06 273.085 357.473 283.195C356.693 285.394 356.209 287.7 356.209 290.034V356.5C356.209 366.441 348.15 374.5 338.209 374.5H30.2086C20.2674 374.5 12.2086 366.441 12.2086 356.5V291.578C12.2086 288.257 11.2517 285.007 9.61444 282.118C1.78214 268.298 2.86228 263.285 8.45268 250.498Z"
          fill={color || '#2e3448'}
        />
      </g>
      {seat ? (
        <>
          <path
            d="M244.208 84C244.208 118.242 216.45 146 182.208 146C147.967 146 120.208 118.242 120.208 84C120.208 49.7583 147.967 22 182.208 22C216.45 22 244.208 49.7583 244.208 84Z"
            fill="white"
          />
          <path
            d="M74.2084 306C74.2084 321.188 65.4485 336 49.7084 336C33.9683 336 20.2285 327.688 20.2285 312.5C20.2105 298.764 34.1348 294.712 49.8961 293C65.6362 293 74.2084 290.812 74.2084 306Z"
            fill="white"
          />
          <path
            d="M290.208 305.109C290.208 320.297 298.968 335.11 314.708 335.11C330.449 335.11 344.188 326.797 344.188 311.609C344.206 297.873 330.282 293.822 314.521 292.109C298.781 292.109 290.208 289.922 290.208 305.109Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M115.319 318.566C101.307 316.044 87.9029 325.359 85.3809 339.371L79.0582 374.5H131.445L136.124 348.504C138.646 334.492 129.331 321.089 115.319 318.566Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M248.58 318.566C262.592 316.044 275.996 325.359 278.518 339.371L284.84 374.5H232.454L227.775 348.504C225.253 334.492 234.568 321.089 248.58 318.566Z"
            fill="white"
          />
          <path
            d="M182.708 156.5C121.708 156.5 121.758 168.391 62.7084 275C72.7084 275.5 92.0084 282.3 89.2084 305.5C96.7084 299.167 121.208 262 121.208 262C128.708 259 135.208 263.5 133.708 272L113.708 304C121.542 304 139.108 308.2 146.708 325H182.708L218.208 325.5C225.808 308.7 243.375 304.5 251.208 304.5L231.208 272.5C229.708 264 236.208 259.5 243.708 262.5C243.708 262.5 268.208 299.667 275.708 306C272.908 282.8 292.208 276 302.208 275.5C243.159 168.891 243.708 156.5 182.708 156.5Z"
            fill="white"
          />
          {!belt ? (
            <>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M232.084 245C232.084 269.853 211.937 290 187.084 290C183.279 290 179.585 289.528 176.056 288.639L147.084 325.5C145.68 323.684 144.493 322.023 143.401 320.495C137.965 312.887 134.892 308.588 119.208 304.976L147.695 266.777C144.119 260.324 142.084 252.9 142.084 245C142.084 220.147 162.231 200 187.084 200C190.392 200 193.616 200.357 196.721 201.034L225.084 163C237.692 168.696 242.615 175.329 249.113 184.086C250.502 185.957 251.962 187.924 253.584 190L226.88 223.975C230.203 230.25 232.084 237.405 232.084 245ZM219.775 245C219.775 263.055 205.139 277.691 187.084 277.691C186.291 277.691 185.505 277.663 184.726 277.608C171.376 276.656 160.242 267.688 156.112 255.489C154.997 252.197 154.393 248.669 154.393 245C154.393 226.945 169.029 212.309 187.084 212.309C187.49 212.309 187.894 212.316 188.296 212.331C202.332 212.843 214.109 222.202 218.217 234.998C219.229 238.15 219.775 241.511 219.775 245Z"
                fill="#E31D1D"
              />
              <rect
                width="11.7937"
                height="45.1556"
                transform="matrix(-0.767467 0.641088 0.641088 0.767467 178.051 224)"
                fill="#E31D1D"
              />
              <rect
                x="197.949"
                y="224"
                width="11.7937"
                height="45.1556"
                transform="rotate(39.873 197.949 224)"
                fill="#E31D1D"
              />
            </>
          ) : (
            <>
              <path
                d="M212.802 235.748L185.126 266.028L180.255 261.575L180.25 261.58L165.208 248.015L175.177 236.961L184.113 245.019L201.788 225.681L207.295 230.715L212.802 235.748Z"
                fill="#128B08"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M232.208 245C232.208 269.853 212.061 290 187.208 290C183.404 290 179.709 289.528 176.181 288.639L147.209 325.5C145.805 323.684 144.618 322.023 143.526 320.495C138.089 312.887 135.017 308.588 119.333 304.976L147.819 266.777C144.244 260.324 142.208 252.9 142.208 245C142.208 220.147 162.356 200 187.208 200C190.516 200 193.741 200.357 196.845 201.034L225.208 163C237.816 168.696 242.739 175.329 249.238 184.086C250.626 185.957 252.086 187.924 253.708 190L227.005 223.975C230.327 230.25 232.208 237.405 232.208 245ZM219.9 245C219.9 263.055 205.263 277.691 187.208 277.691C186.416 277.691 185.63 277.663 184.851 277.608C171.5 276.656 160.366 267.688 156.236 255.489C155.122 252.197 154.517 248.669 154.517 245C154.517 226.945 169.154 212.309 187.208 212.309C187.614 212.309 188.019 212.316 188.421 212.331C202.456 212.843 214.234 222.202 218.341 234.998C219.353 238.15 219.9 241.511 219.9 245Z"
                fill="#128B08"
              />
            </>
          )}
        </>
      ) : (
        <>
          {!belt ? (
            <></>
          ) : (
            <>
              <path
                d="M212.802 235.748L185.126 266.028L180.255 261.575L180.25 261.58L165.208 248.015L175.177 236.961L184.113 245.019L201.788 225.681L207.295 230.715L212.802 235.748Z"
                fill="#128B08"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M232.208 245C232.208 269.853 212.061 290 187.208 290C183.404 290 179.709 289.528 176.181 288.639L147.209 325.5C145.805 323.684 144.618 322.023 143.526 320.495C138.089 312.887 135.017 308.588 119.333 304.976L147.819 266.777C144.244 260.324 142.208 252.9 142.208 245C142.208 220.147 162.356 200 187.208 200C190.516 200 193.741 200.357 196.845 201.034L225.208 163C237.816 168.696 242.739 175.329 249.238 184.086C250.626 185.957 252.086 187.924 253.708 190L227.005 223.975C230.327 230.25 232.208 237.405 232.208 245ZM219.9 245C219.9 263.055 205.263 277.691 187.208 277.691C186.416 277.691 185.63 277.663 184.851 277.608C171.5 276.656 160.366 267.688 156.236 255.489C155.122 252.197 154.517 248.669 154.517 245C154.517 226.945 169.154 212.309 187.208 212.309C187.614 212.309 188.019 212.316 188.421 212.331C202.456 212.843 214.234 222.202 218.341 234.998C219.353 238.15 219.9 241.511 219.9 245Z"
                fill="#128B08"
              />
            </>
          )}
        </>
      )}

      <defs>
        <filter
          id="filter0_d_14_107"
          x="0"
          y="0"
          width="364.243"
          height="382.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_14_107"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_14_107"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default SeatAndBelt;

/* 

<svg width="365" height="387" viewBox="0 0 365 387" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="357" height="387" transform="translate(4)" fill="white"/>
<g filter="url(#filter0_d_14_103)">
<path d="M98.2095 32C98.2095 14.3269 112.536 0 130.21 0H233.209C250.882 0 265.21 14.3269 265.21 32C265.21 49.6731 250.882 64 233.209 64H130.21C112.536 64 98.2095 49.6731 98.2095 32Z" fill="#2e3448"/>
<path d="M53.2094 89.5C53.2094 61.3335 76.043 38.5 104.21 38.5H260.209C288.376 38.5 311.21 61.3335 311.21 89.5V176.5L319.229 265.946C321.905 295.79 298.397 321.5 268.433 321.5H99.4156C70.2142 321.5 46.9751 297.028 48.4835 267.866L53.2094 176.5V89.5Z" fill="#2e3448"/>
<path d="M8.45268 250.498C10.7862 245.161 15.5946 241.29 21.2959 240.095L41.3815 235.883C42.5963 235.628 43.8342 235.5 45.0754 235.5H318.597C319.669 235.5 320.739 235.596 321.795 235.786L344.301 239.85C351.502 241.15 357.289 246.668 358.626 253.862C360.849 265.82 361.06 273.085 357.473 283.195C356.693 285.394 356.209 287.7 356.209 290.034V356.5C356.209 366.441 348.15 374.5 338.209 374.5H30.2086C20.2674 374.5 12.2086 366.441 12.2086 356.5V291.578C12.2086 288.257 11.2517 285.007 9.61444 282.118C1.78214 268.298 2.86228 263.285 8.45268 250.498Z" fill="#2e3448"/>
</g>
<path d="M244.208 84C244.208 118.242 216.45 146 182.208 146C147.967 146 120.208 118.242 120.208 84C120.208 49.7583 147.967 22 182.208 22C216.45 22 244.208 49.7583 244.208 84Z" fill="white"/>
<path d="M74.2084 306C74.2084 321.188 65.4485 336 49.7084 336C33.9683 336 20.2285 327.688 20.2285 312.5C20.2105 298.764 34.1348 294.712 49.8961 293C65.6362 293 74.2084 290.812 74.2084 306Z" fill="white"/>
<path d="M290.208 305.109C290.208 320.297 298.968 335.11 314.708 335.11C330.449 335.11 344.188 326.797 344.188 311.609C344.206 297.873 330.282 293.822 314.521 292.109C298.781 292.109 290.208 289.922 290.208 305.109Z" fill="white"/>
<path fillRule="evenodd" clipRule="evenodd" d="M115.319 318.566C101.307 316.044 87.9029 325.359 85.3809 339.371L79.0582 374.5H131.445L136.124 348.504C138.646 334.492 129.331 321.089 115.319 318.566Z" fill="white"/>
<path fillRule="evenodd" clipRule="evenodd" d="M248.58 318.566C262.592 316.044 275.996 325.359 278.518 339.371L284.84 374.5H232.454L227.775 348.504C225.253 334.492 234.568 321.089 248.58 318.566Z" fill="white"/>
<path d="M182.708 156.5C121.708 156.5 121.758 168.391 62.7084 275C72.7084 275.5 92.0084 282.3 89.2084 305.5C96.7084 299.167 121.208 262 121.208 262C128.708 259 135.208 263.5 133.708 272L113.708 304C121.542 304 139.108 308.2 146.708 325H182.708L218.208 325.5C225.808 308.7 243.375 304.5 251.208 304.5L231.208 272.5C229.708 264 236.208 259.5 243.708 262.5C243.708 262.5 268.208 299.667 275.708 306C272.908 282.8 292.208 276 302.208 275.5C243.159 168.891 243.708 156.5 182.708 156.5Z" fill="white"/>
<path d="M212.802 235.748L185.126 266.028L180.255 261.575L180.25 261.58L165.208 248.015L175.177 236.961L184.113 245.019L201.788 225.681L207.295 230.715L212.802 235.748Z" fill="#128B08"/>
<path fillRule="evenodd" clipRule="evenodd" d="M232.208 245C232.208 269.853 212.061 290 187.208 290C183.404 290 179.709 289.528 176.181 288.639L147.209 325.5C145.805 323.684 144.618 322.023 143.526 320.495C138.089 312.887 135.017 308.588 119.333 304.976L147.819 266.777C144.244 260.324 142.208 252.9 142.208 245C142.208 220.147 162.356 200 187.208 200C190.516 200 193.741 200.357 196.845 201.034L225.208 163C237.816 168.696 242.739 175.329 249.238 184.086C250.626 185.957 252.086 187.924 253.708 190L227.005 223.975C230.327 230.25 232.208 237.405 232.208 245ZM219.9 245C219.9 263.055 205.263 277.691 187.208 277.691C186.416 277.691 185.63 277.663 184.851 277.608C171.5 276.656 160.366 267.688 156.236 255.489C155.122 252.197 154.517 248.669 154.517 245C154.517 226.945 169.154 212.309 187.208 212.309C187.614 212.309 188.019 212.316 188.421 212.331C202.456 212.843 214.234 222.202 218.341 234.998C219.353 238.15 219.9 241.511 219.9 245Z" fill="#128B08"/>
<defs>
<filter id="filter0_d_14_103" x="0" y="0" width="364.243" height="382.5" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14_103"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14_103" result="shape"/>
</filter>
</defs>
</svg>


*/
